import React from "react";

const AddIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="32" height="32" rx="16" fill="#EAF8F4" />
			<path
				d="M21.7144 16.953H16.9525V21.7149C16.9525 22.2387 16.524 22.6673 16.0002 22.6673C15.4764 22.6673 15.0478 22.2387 15.0478 21.7149V16.953H10.2859C9.76207 16.953 9.3335 16.5245 9.3335 16.0007C9.3335 15.4768 9.76207 15.0483 10.2859 15.0483H15.0478V10.2864C15.0478 9.76256 15.4764 9.33398 16.0002 9.33398C16.524 9.33398 16.9525 9.76256 16.9525 10.2864V15.0483H21.7144C22.2383 15.0483 22.6668 15.4768 22.6668 16.0007C22.6668 16.5245 22.2383 16.953 21.7144 16.953Z"
				fill="#1F8268"
			/>
		</svg>
	);
};

export default AddIcon;
